import { inject, Injectable } from '@angular/core';
import { ProductsControllerApiService } from '@lx/shared/api';
import { getDateStringFromDate, getToday } from '@lx/shared/utils';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader } from '@lx/shared/tokens';
import { Memoize } from '@lx/shared/utils-http';

@Injectable({
  providedIn: 'root',
})
export class PriceRequestFiltersService {
  private readonly locale = getLocale();
  private readonly companyHeader = getCompanyHeader();
  private readonly productsControllerApiService = inject(ProductsControllerApiService);

  @Memoize((language: string, cityId: number, courseTypeId: number) => [language, cityId, courseTypeId].join('|'))
  getPriceRequestFilters(language: string, cityId: number, courseTypeId: number) {
    return this.productsControllerApiService.getPriceRequestFilters(
      language,
      cityId,
      courseTypeId,
      this.locale,
      this.companyHeader,
      getDateStringFromDate(getToday()),
    );
  }
}
